S.header =
    {
        config: {
            // height navbar
            offset: -20,
        },

        elements: {
            $menuIcon: null,
            $searchIconMobile: null,
            // $searchIconDesktop: null,
            $navigation: null,
            $searchLayer: null,
        },

        init()
        {
            this.menuMobile();
            this.searchLayerMobile();
            // this.searchLayerDesktop();
            this.listen();
            this.scrollSticky();
            this.scrollMenu();
        },

        /* set top from mobilenav by iconclick */
        startPositionMobileNav()
        {
            const navHeight = this.elements.$navigation[0].scrollHeight - this.config.offset;

            // mobile and tablet only
            if (!S.mq('desktop', false).matches)
            {
                // console.log(navHeight);
                this.elements.$navigation.css('top', -navHeight);

            }
        },

        openMobileNav()
        {
            this.$module.addClass('is-mobile-nav-open');
            this.startPositionMobileNav();

            setTimeout(() =>
            {
                this.elements.$navigation.css('top', '52px');
            }, 40);

            if (this.elements.$searchLayer.hasClass('is-active'))
            {
                this.searchLayerClose();
            }

            this.elements.$searchIconMobile.removeClass('is-active');
            S.bglayer.open();
        },

        closeMobileNav()
        {
            this.$module.removeClass('is-mobile-nav-open');
            this.startPositionMobileNav();
            S.bglayer.close();
        },

        menuMobile()
        {
            this.elements.$menuIcon.on('click', () =>
            {
                if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    this.closeMobileNav();
                }
                else
                {
                    this.openMobileNav();
                }
            });
        },

        setDesktopNav()
        {
            this.elements.$navigation.css('top', 0);
        },

        searchLayerClose()
        {
            this.elements.$searchLayer.stop().fadeOut();
            this.elements.$searchLayer.removeClass('is-active');
            this.elements.$searchIconMobile.removeClass('is-active');
            S.bglayer.close();
        },

        searchLayerOpen()
        {
            this.elements.$searchLayer.stop().fadeIn();
            this.elements.$searchLayer.addClass('is-active');
            //close menu if search opened
            if (this.$module.hasClass('is-mobile-nav-open'))
            {
                this.closeMobileNav();
            }
            S.bglayer.open();
        },

        searchLayerMobile()
        {
            this.elements.$searchIconMobile.on('click', () =>
            {
                if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    this.elements.$searchIconMobile.removeClass('is-active');
                    this.searchLayerClose();
                    S.bglayer.close();
                }
                else
                {
                    this.searchLayerOpen();
                    this.elements.$searchIconMobile.addClass('is-active');

                    if (this.$module.hasClass('is-mobile-nav-open'))
                    {
                        this.closeMobileNav();
                    }

                    S.bglayer.open();
                }
            });
        },

        searchLayerDesktop()
        {
            this.elements.$searchIconDesktop.on('click', () =>
            {
                if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    this.searchLayerClose();
                }
                else
                {
                    this.searchLayerOpen();
                    this.elements.$searchIconMobile.addClass('is-active');
                }
            });
        },
        scrollMenu(){
            $('nav a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('active');
        },

        scrollSticky(){
            $(window).scroll(function() {
                if( $(document).scrollTop() == 0){
                    $('.mod-header').removeClass('sticky');
                }

                $(window).scroll(function(){
                    if ($(window).scrollTop() >= 300) {
                        $('.mod-header').addClass('sticky');
                    }
                    else {
                        $('.mod-header').removeClass('sticky');
                    }
                });

            });
        },

        listen()
        {
            S.mq('desktop').addListener((mq) =>
            {
                // S.header.closeMobileNav();
                if (mq.matches)
                {
                    if (this.$module.hasClass('is-mobile-nav-open'))
                    {
                        this.setDesktopNav();
                        S.bglayer.close();
                    }
                    else
                    {
                        this.setDesktopNav();
                    }
                }
                else if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    // S.slide.openAllSlides();
                    S.bglayer.open();
                }
                else
                {
                    // S.slide.openAllSlides();
                    this.startPositionMobileNav();
                }
            });
        },
    };